import * as React from "react";
import styles from "./index.module.scss";
import Image from "next/image";
import { useEffect, useState, useRef } from "react";
import { NextPage, GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import dynamic from "next/dynamic";
import Layout from "@/components/layout";
import { useWidth } from "@/utils/resize";
import { watchDom } from "@/watch";
import buriedsdk from "@/utils/zz-buried/index";
import Matrix from "@@/matrix";
import Performance from "@@/matrix/performance";
const PcFreestart = dynamic(import("@home3/pc/Freestart"));

import banner from "@images/features/influencer/banner.png";
import b1 from "@images/features/influencer/b1.png";
import b2 from "@images/features/influencer/b2.png";
import b3 from "@images/features/influencer/b3.png";
import sec1 from "@images/features/influencer/sec1.png";
import sec2 from "@images/features/influencer/sec2.png";
import sec3 from "@images/features/influencer/sec3.png";

type Props = {};

let watchDoms: any = "";
const Index = (props: Props) => {
  const { t, i18n } = useTranslation("features");
  const dom: any = useRef();
  const { width, display } = useWidth();

  const mobileUrl = process.env.mobileUrl;
  const pcUrl = process.env.portalUrl;

  const list = [
    {
      title: t("Page Influencer Content1 Title"),
      title2: "",
      tip: t("Page Influencer Content1 Desc"),
      bg: "#fff",
      img: sec1,
      alt: t("Page Influencer Content1 Title"),
      pcUrl: pcUrl + "/influencer/sales?name=hot",
      mUrl: mobileUrl + "/rank?type=Influencers&rankType=breakout",
    },
    {
      title: t("Page Influencer Content2 Title"),
      title2: "",
      tip: t("Page Influencer Content2 Desc"),
      btnWords: "Explore Now",
      bg: "linear-gradient(135deg, #F6FEFF 0%, #FFEFEF 100%);",
      img: sec2,
      alt: t("Page Influencer Content2 Title"),
      pcUrl: pcUrl + "/discovery/influencers",
      mUrl: mobileUrl + "/discovery?type=influencers",
    },
    {
      title: t("Page Influencer Content3 Title"),
      title2: "",
      tip: t("Page Influencer Content3 Desc"),
      bg: "#ff",
      img: sec3,
      alt: t("Page Influencer Content3 Title"),
      pcUrl: pcUrl + "/discovery/influencers",
      mUrl: mobileUrl + "/discovery?type=influencers",
    },
  ];
  const handleJump = () => {
    buriedsdk.buried({
      event: `按钮点击`,
      scene: `Start Free Trial按钮`,
      URL: process.env.publicApiDomain,
    });
  };

  useEffect(() => {
    if (process.browser) {
      if (dom.current) {
        if (watchDoms) clearInterval(watchDoms);
        watchDoms = watchDom();
      }
    }
  }, [dom]);

  return (
    <div>
      <Layout header={true} footer={true}>
        <Head>
          <title>{t("Page Influencer Title")}</title>
          <meta name="keywords" content={t("Page Influencer Keywords")}></meta>
          <meta name="description" content={t("Page Influencer Description")} />
          <script src="/js/jq.js" async />
          <script src="/js/kefu53.js" async />
        </Head>
        <div className={styles.down} ref={dom}>
          <div className={styles.center + " defeaultContainer"}>
            <div className={styles.banner}>
              <div className={styles.info + " animate-box"}>
                <h2 className={styles.title + " ant"}>
                  {t("Page Influencer Banner Title")}
                </h2>
                <p className={styles.desc + " ant mr-[16px]"}>
                  {t("Page Influencer Banner Desc")}
                </p>
                <a
                  rel="noreferrer"
                  onClick={handleJump}
                  href={
                    width > 1024
                      ? pcUrl + "/discovery/influencers"
                      : mobileUrl + "/discovery?type=influencers"
                  }
                  target="_blank"
                  className={styles.btn + " ant"}
                >
                  {t("Start Free Trial")}
                </a>
              </div>
              <div className={styles.imgWrap + " animate-box"}>
                <Image
                  className="ant"
                  width={635}
                  height={619}
                  src={banner}
                  alt=""
                ></Image>
                <div
                  className={
                    styles["img-item"] +
                    " ant absolute top-[107px] left-[-12px] md:top-[85px] md:left-[-8px]"
                  }
                >
                  <Image
                    width={width > 1024 ? 240 : 144}
                    height={width > 1024 ? 71 : 43}
                    src={b1}
                  ></Image>
                </div>
                <div
                  className={
                    styles["img-item"] +
                    " ant absolute bottom-[115px] left-[-12px] md:bottom-[62px] md:left-[-5px]"
                  }
                >
                  <Image
                    width={width > 1024 ? 226 : 124}
                    height={width > 1024 ? 146 : 80}
                    src={b2}
                  ></Image>
                </div>
                <div
                  className={
                    styles["img-item"] +
                    " ant absolute bottom-[138px] right-[-19px] md:bottom-[111px] md:right-[-10px]"
                  }
                >
                  <Image
                    width={width > 1024 ? 240 : 128}
                    height={width > 1024 ? 155 : 82}
                    src={b3}
                  ></Image>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Matrix list={list}></Matrix>
          <Performance name="Pick Influencers"></Performance>
          <PcFreestart></PcFreestart>
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = context;
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "home",
        "common",
        "nav",
        "footer",
        "features",
      ])),
      context: {
        locale,
        req: {
          headers: context.req.headers,
        },
      },
    },
  };
};

export default Index;
